var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"variant":"success","show":""}},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }